module.exports = __webpack_public_path__ + "img/logo-garena.b1bec315.png";